export default {
  status: {
    pending: {
      key: 'pending',
      label: 'Access requested',
    },
    accepted: {
      key: 'accepted',
      label: 'Access request approved',
    },
    rejected: {
      key: 'rejected',
      label: 'Access request declined',
    },
  },
};
